module.exports = __webpack_public_path__ + "img/enigma-red-4.558aabde.png";